import FilterTag from './src/filter-tag.vue';

FilterTag.install = function (Vue) {
  Vue.component(FilterTag.name, FilterTag);
};

export default FilterTag;
